import {useDispatch} from "react-redux";
import React, {useCallback, useEffect, useState} from "react";
import {changePageTitle, setAlert} from "../typescript/redux/actions";
import {Grid} from "@mui/material";
import {UserGoalService} from "./user-goal.service";
import CustomTextField from "../typescript/custom-text-field/custom-text-field";
import CustomButton from "../typescript/custom-button/custom-button";
import CustomButtonGroup from "../typescript/custom-button-group/custom-button-group";
import {UserService} from "../user/user.service";
import ForeignKey from "../typescript/foreign-key/foreign-key";

export function UserGoalDetail({id, onClose, dialog}) {

    const [item, setItem] = useState(UserGoalService.createUserGoal());
    const dispatch = useDispatch();

    const findOne = useCallback(async () => {
        const result = await UserGoalService.findOne(id);
        setItem(result);
    }, [id]);

    useEffect(() => {
        if (!dialog) {
            dispatch(changePageTitle(id ? "Meta de usuário " + id : "Nova meta de usuário"));
        }
        if (id) {
            findOne().then();
        }
    }, [dispatch, findOne, id, dialog]);

    const save = (event) => {
        event.preventDefault();
        event.stopPropagation();
        UserGoalService.save(item).then((result) => {
            onClose(result.data);
        }).catch((error) => {
            let message = 'Erro ao criar meta';
            if (error.response.data.message) {
                message += ' - ' + error.response.data.message;
            }
            dispatch(setAlert({show: true, message: message, severity: 'error'}));
        })
    }

    const cancel = () => {
        onClose();
    }

    const setAno = (event) => {
        setItem({
            ...item,
            ano: event.target.value
        })
    }

    const setMes = (event) => {
        setItem({
            ...item,
            mes: event.target.value
        })
    }

    const setMetaMinima = (event) => {
        setItem({
            ...item,
            metaMinima: event.target.value
        })
    }

    const setMetaBasica = (event) => {
        setItem({
            ...item,
            metaBasica: event.target.value
        })
    }

    const setMetaMaster = (event) => {
        setItem({
            ...item,
            metaMaster: event.target.value
        })
    }

    const setMetaSuper = (event) => {
        setItem({
            ...item,
            metaSuper: event.target.value
        })
    }

    const onChangeUsuario = async (id) => {
        setItem({
            ...item,
            usuario: {
                id: id
            }
        })
        if (id) {
            const usuario = await UserService.findOne(id);
            if (usuario) {
                setItem({
                    ...item,
                    usuario: usuario
                })
            }
        }
    }

    const onAddUsuario = (usuario) => {
        if (usuario) {
            setItem({
                ...item,
                usuario: usuario
            })
        }
    }

    const findUsuarios = (page, size, sort, filter) => {
        return UserService.findAll(page, size, sort, filter);
    }

    return (
        <form onSubmit={save}>
            <ForeignKey fullWidth autoFocus required label="Usuário" value={item.usuario} fieldKey={'id'}
                        fieldDescription={'username'} labelDescription='Usuário' onChange={onChangeUsuario}
                        onSelect={onAddUsuario} findAll={findUsuarios} dataColumnNames={['ID', 'Usuário']}
                        dataColumns={['id', 'username']} dataTypes={['number', 'text']}/>
            <Grid container spacing={1}>
                <Grid item md xs={12}>
                    <CustomTextField type="number" fullWidth required label="Ano" value={item.ano}
                                     onChange={setAno}/>
                </Grid>
                <Grid item md xs={12}>
                    <CustomTextField type="number" fullWidth required label="Mês" value={item.mes}
                                     onChange={setMes}/>
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item md xs={12}>
                    <CustomTextField type="number" fullWidth required label="Meta mínima" inputProps={{step: "0.01"}} value={item.metaMinima}
                                     onChange={setMetaMinima}/>
                </Grid>
                <Grid item md xs={12}>
                    <CustomTextField type="number" fullWidth required label="Meta básica" inputProps={{step: "0.01"}} value={item.metaBasica}
                                     onChange={setMetaBasica}/>
                </Grid>
                <Grid item md xs={12}>
                    <CustomTextField type="number" fullWidth required label="Meta master" inputProps={{step: "0.01"}} value={item.metaMaster}
                                     onChange={setMetaMaster}/>
                </Grid>
                <Grid item md xs={12}>
                    <CustomTextField type="number" fullWidth required label="Meta super" inputProps={{step: "0.01"}} value={item.metaSuper}
                                     onChange={setMetaSuper}/>
                </Grid>
            </Grid>
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Salvar</CustomButton>
                <CustomButton type="button" color="neutral" onClick={cancel}>Cancelar</CustomButton>
            </CustomButtonGroup>
        </form>
    )
}
